export default "__VITE_ASSET__Tpocrinl__"